<template>
  <div :class="['layout_container_main', `direction_${direction}`, `${flex? 'flex' : ''}`]">
    <slot></slot>
  </div>
</template>
<script>
export default {
  props: {
    direction: {
      type: String,
      default: 'row'
    },
    flex: {
      type: Boolean,
      default: false
    }
  }
}
</script>
<style lang="scss" scoped>
  .layout_container_main {
    flex: 1;
    background-color: $bg-color-main;
    padding: 16px;
    overflow: auto;
    &.direction {
      &_row {
        flex-direction: row;
      }
      &_column {
        flex-direction: column
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/container/main/index.vue